// extracted by mini-css-extract-plugin
export var main_div = "index-module--main_div--Nqqw2";
export var blogs_div = "index-module--blogs_div--At3ee";
export var image1_setting = "index-module--image1_setting--2134u";
export var medium_heading = "index-module--medium_heading--3W4eC";
export var date_setting = "index-module--date_setting--1B2IX";
export var all_recruiting2 = "index-module--all_recruiting2--1t4Nk";
export var olivia = "index-module--olivia--17UF1";
export var loading_gif = "index-module--loading_gif--iEKt_";